import React from "react"
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core'
import { GlobalStyle } from '../utils/styles'
import classNames from 'classnames';
// import CustomKeyboard from './keyboard'
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import '../styles/components/_tagInput.scss'
import { withTranslation } from 'react-i18next';


class TagInput extends React.Component {
// const TagInput = ({ tagInputChange, backtoCompStage, revertTag, saveTag, classes }) => {
// const currentDesign = useSelector(state => state.currentDesign)
  constructor () {
    super();
    this.state = {
      input: "",
      keyboardDisplay: 'hide',
      width: 0,
      height: 0
    }
    this.myRef = React.createRef();
    this.showKeyboard = this.showKeyboard.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    const defaultValue = this.props.currentTag
    this.setState({
      input: defaultValue
    });
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    const refWidth = this.myRef.current.clientWidth
    const refHeight = this.myRef.current.clientWidth
    this.setState({ width: refWidth, height: refHeight });
  }

  onChangeKeyboard = input => {
    const value = input.toUpperCase()
    this.setState({
      input: value
    });
    this.props.tagValueChange(value)
  }

  onChangeInput = event => {
    // const input = event.target.value;
    // const value = input.toUpperCase()
    // const reg = /[A-Za-z⭑☀☺ ]/g;
    // console.log(reg.test(value))
    // if ((reg.test(value) || !value.length) && value.length < 4) {
    //   console.log('t')
    //   this.setState(
    //     {
    //       input: value
    //     },
    //     () => {
    //       this.keyboard.setInput(value);
    //     }
    //   );
    //   this.props.tagValueChange(value)
    // }
  }

  showKeyboard = () => {
    this.setState({
      keyboardDisplay: 'show'
    });
  }

  hideKeyboard = () => {
    this.setState({
      keyboardDisplay: 'hide'
    });
  }

  render() {
    const t = this.props.t
    return (
      <div className="tagInput">
        {/* <form className={classes.selectStatic}> */}
        <h2 className="desktop">{ t('product.component.tag') }</h2>
        <form>
          <label>
            { t('tagDescription') }
            <br/>
            {/* <input type="text" name="name" defaultValue={currentDesign.tag} onChange={tagInputChange} maxLength="3" /> */}
            <input
              ref={this.myRef}
              type="text"
              value={this.state.input}
              placeholder={""}
              onChange={e => this.onChangeInput(e)}
              readOnly="readonly"
              maxLength="3"
              onFocus={e => {this.showKeyboard(); this.keyboard.setInput(this.state.input)}}
              onBlur={e => this.hideKeyboard() }
            />
            <div className={this.state.keyboardDisplay}>
              <Keyboard
                maxLength={3}
                keyboardRef={r => (this.keyboard = r)}
                onChange={input => this.onChangeKeyboard(input)}
                preventMouseDownDefault={true}
                layoutName={this.state.width > 500 ? 'default' : 'mobile'}
                layout={{
                  'default': [
                    'A B C D E F G H I J K L M',
                    'N O P Q R S T U V W X Y Z',
                    '☀ ☺ ⭑ {space} {bksp}'
                  ],
                  'mobile': [
                    'A B C D E F G H I J K L M',
                    'N O P Q R S T U V W X Y Z',
                    '☀ ☺ ⭑ {space} {bksp}'
                  ]
                }}
                display={{
                  '{bksp}': t('del'),
                  '{space}': t('space'),
                }}
              />
            </div>
          </label>
        </form>
        <div className="buttonGroup stickToBottom">
          <Button className="basicButton outline" onClick={() => {this.props.backtoCompStage(); this.props.revertTag()}}>{ t('product.cancel') }</Button>
          <Button className="basicButton" onClick={() => {this.props.backtoCompStage(); this.props.saveTag()}}>{ t('confirm') }</Button>
        </div>
      </div>
    )
  }
}

export default withTranslation()(TagInput)

// export default withStyles(GlobalStyle)(TagInput)

